/**
 *
 * @param fnA
 * @param fnB
 */
const compose = (fnA:Function, fnB:Function):Function=>(x)=>fnA(fnB(x));
export default compose;


// WEBPACK FOOTER //
// ./src/compose.ts